import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import DataUsers from './components/DataUsers/DataUsers';
import './style.scss';
import { showModal, MODAL_FORM_TEACHER } from '../../modules/modals';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import WrappedIntlComponent from '../common/intl/WrappedIntlComponent';
import { routesUrls } from '../../settings/routes';
import {Link} from 'react-router-dom'
import OrganisationName from './components/OrganisationName';
import { isTeacherOrganisationSelector } from '../../modules/profile';

class UserOrganisation extends Component {
  
  render() {
    const {showModal, formatMessage} = this.props;
    return (
      <Wrapper renderButtonNav = {false} >
        <div className="UserOrganisation">
          <div className="row">
            <OrganisationName />
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <button
                className="btn-create"
                onClick={() => {
                  showModal({
                    modalType : MODAL_FORM_TEACHER,
                    modalProps : {
                      initialValues: {
                        permission: {
                          allow_delete_question: 1,
                          allow_empty_trash: 1,
                          add_new_question: 1,
                          classrooms: 1,
                          quizzes: 1,
                          statistics: 1,
                          lecture_hall: 1,
                          flash_card: 1,
                        }
                      }
                    }
                  })
                }}
              >+ {formatMessage('txtCreatTeacher')}</button>
              <Link to={routesUrls.transactions}
                className="btn-create"
                style={{background: '#00adff', color: 'white', textAlign: 'center', justifyContent: 'center'}}
              >{formatMessage('txtTeacherTransaction')}</Link>
            </div>
            <DataUsers />
          </div>
        </div>
      </Wrapper>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  showModal
}

export default WrappedIntlComponent(connect(mapStateToProps, mapDispatchToProps)(UserOrganisation))



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/UserOrganisation/index.jsx